module.exports = __webpack_public_path__ + "img/5.0ff31091.jpg";